export default "__VITE_ASSET__xw0t4taG__"